import { render, staticRenderFns } from "./GlueEdit.vue?vue&type=template&id=3b2f74a1&"
import script from "./GlueEdit.vue?vue&type=script&lang=ts&"
export * from "./GlueEdit.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports